<template >
  <div  :style="{ 'height': hasKpi ? '14px' : '100px'}"
        class="ti_bg"></div>
</template>

<script>
export default {
  props: {
    hasKpi: { type: Boolean, default: true }
  }
}
</script>